
import React, { useContext } from "react";
import { Box, useTheme, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { UserAuth } from "../context/AuthContext";
import Header from "./Header";
import TokenContext from "../context/TokenContext";
import { reuniones, crearReunion } from "../Redux/reunionesCientificas";
import TablaReuniones from "./tablas/TablaReuniones";
import { COLUMNSCIENTIFICAS } from "../columnas/columnasReuniones";
import ModalCientificas from "./modales/ModalCientificas";

const ReunionesCientificas = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const token = useContext(TokenContext);
    const { empleado } = UserAuth();

    const [reunionesCientificas, setReunionesCientificas] = React.useState([])
    const reunionesSelector = useSelector(store => store.cientificas.reunionesCientificas)

    const [openModal, setOpenModal] = React.useState(false)
    const handleOpen = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);

    React.useEffect(() => {
        if (token, empleado) {
            dispatch(reuniones(token, empleado.usuarioPortalRh))
        }
    }, [token, empleado]);

    React.useEffect(() => {
        if (reunionesSelector?.length > 0) {
            var array = []
            reunionesSelector.forEach(element => {
                var objeto = {
                    id: element.new_reunioncientficaid,
                    new_formadeparticipacin: element["new_formadeparticipacin@OData.Community.Display.V1.FormattedValue"],
                    new_evento: element.new_evento,
                    new_fecha: element["new_fecha@OData.Community.Display.V1.FormattedValue"],
                    new_lugar: element.new_lugar,
                    new_name: element.new_name
                }
                array.push(objeto)
            });
            setReunionesCientificas(array)
        }
    }, [reunionesSelector])

    const handleSubmit = (datos) => {
        dispatch(crearReunion(empleado.empleadoid, datos, token))
            .then((id) => {
                handleClose()
                dispatch(reuniones(token, empleado.usuarioPortalRh))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box m="1.5rem 2.5rem">
                <Header
                    title={"Participación en Reuniones Científicas o Eventos Artísticos"}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <TablaReuniones columnas={COLUMNSCIENTIFICAS} lineas={reunionesCientificas} handleOpen={handleOpen} />
                    </Grid>
                </Grid>
            </Box>
            <ModalCientificas open={openModal} handleClose={handleClose} onSubmit={handleSubmit} />
        </motion.div>
    )
}

export default ReunionesCientificas